import { Paper } from '@mui/material';
import theme from 'library/theme/theme';
import styled from 'styled-components';

export const Main = styled.main`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const SignInWrapper = styled(Paper).attrs({ variant: 'outlined' })`
  width: 600px;
  padding: ${theme.spacing(3)};
`;
